// Step 23 — contract comparison table.
//
// Reads the workspace `listContracts` payload (contract_summary_dict
// rows). Every column value is authoritative data the backend already
// gave us — no invented completion percentage, no fake clause coverage,
// no synthesized quality score. Only draft-level metadata is
// compared; there is no first-class ContractClause model, so no
// clause-level diff is faked here.

import { Link } from "react-router-dom";

import AIContractAttentionChips from "./AIContractAttentionChips";
import { contractKindLabel, contractStatusLabel } from "./helpers";

function _fmtWhen(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("sv-SE");
  } catch {
    return String(iso);
  }
}

export default function AIContractComparisonTable({ rows, workspaceId }) {
  return (
    <table className="qai-contract-compare">
      <thead>
        <tr>
          <th>Utkast</th>
          <th>Typ</th>
          <th>Status</th>
          <th>Köpare</th>
          <th>Variabler</th>
          <th>Klausuler</th>
          <th>Osäkerheter</th>
          <th>Uppdaterad</th>
          <th>Signaler</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {rows.map((c) => (
          <tr key={c.id} data-contract-row={c.id}>
            <td>
              <Link
                to={`/deals/${workspaceId}/contracts/${c.id}`}
                className="qai-deals-link"
              >
                {c.title || `#${c.id}`}
              </Link>
            </td>
            <td>{contractKindLabel(c.kind)}</td>
            <td>
              <span
                className="qai-contract-status-badge"
                data-status={c.status}
              >
                {contractStatusLabel(c.status)}
              </span>
            </td>
            <td>
              {c.acquirer_name ? (
                c.acquirer_id ? (
                  <Link
                    to={`/deals/${workspaceId}/buyers/${c.acquirer_id}`}
                    className="qai-page-section-link"
                  >
                    {c.acquirer_name}
                  </Link>
                ) : (
                  c.acquirer_name
                )
              ) : (
                <span className="qai-contract-compare-none">—</span>
              )}
            </td>
            <td>{c.variables_count ?? 0}</td>
            <td>{c.clauses_count ?? 0}</td>
            <td>{c.uncertainties_count ?? 0}</td>
            <td>{_fmtWhen(c.updated_at)}</td>
            <td>
              <AIContractAttentionChips row={c} />
            </td>
            <td>
              <Link
                to={`/deals/${workspaceId}/contracts/${c.id}`}
                className="qai-page-section-link"
              >
                Öppna →
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
